import React, { useState, useCallback } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import { useLenis } from "@/hooks/useLenis";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Services from "@/components/Services";
import VideoGallery from "@/components/VideoGallery";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import AdminLogin from "@/pages/admin/Login";
import AdminDashboard from "@/pages/admin/Dashboard";
import RequestDetail from "@/pages/admin/RequestDetail";

function Landing() {
  useLenis();
  const [tab, setTab] = useState("quote");

  const scrollToContact = useCallback((which) => {
    setTab(which);
    const el = document.querySelector("#contact");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  }, []);

  return (
    <div className="min-h-screen bg-[#05070A] text-white antialiased">
      <Nav />
      <main>
        <Hero
          onQuote={() => scrollToContact("quote")}
          onBook={() => scrollToContact("book")}
        />
        <About />
        <Services onQuote={() => scrollToContact("quote")} />
        <VideoGallery />
        <Contact activeTab={tab} setActiveTab={setTab} />
      </main>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<ProtectedRoute><AdminDashboard type="quotes" /></ProtectedRoute>} />
          <Route path="/admin/consultations" element={<ProtectedRoute><AdminDashboard type="consultations" /></ProtectedRoute>} />
          <Route path="/admin/quotes/:id" element={<ProtectedRoute><RequestDetail type="quote" /></ProtectedRoute>} />
          <Route path="/admin/consultations/:id" element={<ProtectedRoute><RequestDetail type="consultation" /></ProtectedRoute>} />
        </Routes>
        <Toaster richColors position="top-right" theme="dark" />
      </BrowserRouter>
    </AuthProvider>
  );
}
